/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/mv_intersects.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Checks if any value yielded by the second multivalue expression is present in the values yielded by the first multivalue expression. Returns a boolean. Null values are treated as an empty set.',
  examples: [
    'ROW set = ["a", "b", "c"], element = "a"\n| EVAL set_intersects_element = mv_intersects(set, element)',
    'ROW setA = ["a","c"], setB = ["a", "b", "c"]\n| EVAL a_intersects_b = mv_intersects(setB, setA)\n| EVAL b_intersects_a = mv_intersects(setA, setB)',
    'FROM airports\n| WHERE mv_intersects(type, ["major"]) AND scalerank == 9\n| KEEP scalerank, name, country\n| SORT country',
  ],
  params: {
    field1: 'Expression that can be null, a single value, or multiple values.',
    field2: 'Expression that can be null, a single value, or multiple values.',
  },
};

export default docs;
